import { memo, type PropsWithChildren } from 'react';
import { Helmet } from "react-helmet-async";
import type { ScreenProps } from './types';
import { Authorized } from '../Auth';

const Screen = ({
    children,
    fallback,
    roles = [],
    ...helmetProps
}: PropsWithChildren<ScreenProps>) => (
    <>
        <Helmet
            {...helmetProps}
        />
        <Authorized
            roles={roles}
            fallback={fallback}
        >
            {children}
        </Authorized>
    </>
);

export default memo(Screen);
